import { deleteCostRule} from '@process-advisor/process-miner/processMiner/processMiner';
import { Event } from '@process-advisor/process-miner/api/events';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    costID?: Number,
}

export const deleteCost = ({costID,eventEmitter}: Props) => {
    deleteCostRule(costID)
    eventEmitter.emit(Event.updateCost);
};

